import Ajv from 'ajv';
import * as logger from '../utils/logger';
import schemas from '../chromecast.schema.json';

const ajv = new Ajv();
const log = logger.create('Schema');

/**
 * Validate the schema of a given name with the data.
 * @param {string} name Name of the schema to validate.
 * @param {Object} data Data to validate.
 */
export function validateSchema(name, data) {
  if (process.env.VALIDATOR_ENABLED) {
    const validator = ajv.compile(schemas.definitions[name]);
    if (!validator(data)) {
      validator.errors.map((err) => log.error(err));
    }
  } else {
    return true;
  }
}
